import { render } from "./ColorPicker.vue?vue&type=template&id=7940da6e"
import script from "./ColorPicker.vue?vue&type=script&lang=js"
export * from "./ColorPicker.vue?vue&type=script&lang=js"

import _style_0 from "./ColorPicker.vue?vue&type=style&index=0&id=7940da6e&inline&lang=scss"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]]])

export default __exports__